export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg
    viewBox="0 0 48 48"
    className={`${className} drop-shadow-[0_3px_12px_rgba(245,158,11,0.4)]`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="ip-badge" x1="4" y1="2" x2="44" y2="46" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FBBF24" />
        <stop offset="0.5" stopColor="#F59E0B" />
        <stop offset="1" stopColor="#06B6D4" />
      </linearGradient>
      <clipPath id="ip-clip">
        <rect x="2" y="2" width="44" height="44" rx="14" />
      </clipPath>
    </defs>
    <g clipPath="url(#ip-clip)">
      <rect x="2" y="2" width="44" height="44" fill="url(#ip-badge)" />
      <ellipse cx="13" cy="4" rx="28" ry="15" fill="#ffffff" opacity="0.20" />
      <circle cx="42" cy="44" r="12" fill="#06B6D4" opacity="0.35" />
    </g>
    {/* roofline */}
    <path d="M12.5 27.5 L24 15 L35.5 27.5" stroke="#0B0C10" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    {/* home body */}
    <path d="M17.5 26 V34.5 H30.5 V26" stroke="#0B0C10" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    {/* insight dot */}
    <circle cx="24" cy="30.5" r="2.4" fill="#0B0C10" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5 select-none group" data-testid="brand-logo">
    <LogoMark className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[6deg] group-hover:scale-105" />
    {!compact && (
      <div className="leading-none">
        <div className="font-display font-extrabold text-[1.2rem] tracking-tight text-white">
          Insight<span className="text-gradient-amber"> Properties</span>
        </div>
        <div className="font-mono text-[0.6rem] uppercase tracking-[0.26em] text-muted-foreground mt-1">
          trading as INSITE IQ LTD
        </div>
      </div>
    )}
  </div>
);
